export default "__VITE_ASSET__e2784be6__"